/**
 * Created by frank.law on 12/13/17.
 */
import React from 'react';
import '../../css/login.css';


class LoadingContainer extends React.Component {

    render () {
        return (
            <div className="loading-box">
                <div key="loading-spinner" className="wd-player-spinner"><span></span></div>
            </div>
        );
    }
}

export default LoadingContainer;
